/**
 * Explicit Angular bootstrap. Last file in both bundles.
 *
 * vendor.min.js and the page bundle are deferred (perf 1c). Angular's ng-app
 * auto-bootstrap runs through jQuery's ready handler, which is a setTimeout
 * once the document is no longer "loading" — i.e. it is queued the moment
 * vendor.min.js finishes. If the browser yields before the page bundle has
 * executed (it is still downloading on a cold cache), Angular bootstraps
 * before the app module exists, fails silently, and the SPA loader spins
 * forever; a reload, with the bundle cached, does not hit the gap. So the
 * layouts carry data-ui8-app instead of ng-app and we bootstrap here.
 */
(function () {
  var root = document.documentElement;
  var name = root.getAttribute("data-ui8-app");
  if (!name) return;
  angular.element(function () {
    angular.bootstrap(root, [name]);
  });
})();
